
import React, { createContext, useContext, useEffect, useState } from "react";

type FontSizeContextType = {
  fontSize: number;
  setFontSize: (size: number) => void;
};

const FontSizeContext = createContext<FontSizeContextType | undefined>(undefined);

export const FontSizeProvider = ({ children }: { children: React.ReactNode }) => {
  // Get initial font size from localStorage or use default of 16
  const [fontSize, setFontSize] = useState(() => {
    const savedSize = localStorage.getItem("app-font-size");
    return savedSize ? parseInt(savedSize, 10) : 16;
  });

  // Apply font size to html element and save to localStorage when it changes
  useEffect(() => {
    document.documentElement.style.fontSize = `${fontSize}px`;
    localStorage.setItem("app-font-size", fontSize.toString());
    
    // Add a CSS variable that can be used for responsive sizing
    document.documentElement.style.setProperty('--font-size-factor', `${fontSize / 16}`);
  }, [fontSize]);

  return (
    <FontSizeContext.Provider value={{ fontSize, setFontSize }}>
      {children}
    </FontSizeContext.Provider>
  );
};

export const useFontSize = (): FontSizeContextType => {
  const context = useContext(FontSizeContext);
  if (context === undefined) {
    throw new Error("useFontSize must be used within a FontSizeProvider");
  }
  return context;
};
